import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { TextHighlighter } from '../../components';
import { useIconMargin, useSuggestSelectedItem } from '../../hooks';
import { SuggestionTitleItem } from '../../components/SuggestionTitleItem';
import { SuggestionTextItem } from '../../components/SuggestionTextItem';
import { ModalWindow } from '../../../../modal';
import { SuggestModalMobile } from '../../components/SuggestModalMobile';
import { SuggestModalMobileHeader } from '../../components/SuggestModalMobileHeader';
import { SuggestionMobileDefaultItem } from '../../components/SuggestionMobileDefaultItem';
import { useMaxLinesCssVarable } from '../../hooks/useMaxLinesCssVarable';
import { SUGGEST_PROP_DEFAULTS } from '../../constants';
import { useSuggestMouseEvents } from '../../hooks/useSuggestMouseEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
var suggestItemComponentMap = {
  default: SuggestionMobileDefaultItem,
  title: SuggestionTitleItem
};
export var SuggestMobile = function SuggestMobile(props) {
  var onSelect = props.onSelect,
    onClose = props.onClose;
  var headerRef = React.useRef(null);
  var listRef = React.useRef(null);
  useMaxLinesCssVarable({
    ref: listRef,
    maxLines: props.maxLines,
    open: props.open
  });
  var _useIconMargin = useIconMargin(props.suggestions),
    getIconMarginForItem = _useIconMargin.getIconMarginForItem,
    setTitleItemRefByIndex = _useIconMargin.setTitleItemRefByIndex;
  var onItemClick = React.useCallback(function (item) {
    return function () {
      return onSelect === null || onSelect === void 0 ? void 0 : onSelect(item, {
        source: 'click'
      });
    };
  }, [onSelect]);
  var onModalClose = React.useCallback(function () {
    return onClose === null || onClose === void 0 ? void 0 : onClose({
      source: 'mobileModal'
    });
  }, [onClose]);
  React.useEffect(function () {
    if (props.open && headerRef.current) {
      Array.from(headerRef.current.getElementsByTagName('input')).forEach(function (el) {
        return el.focus();
      });
    }
  }, [props.open]);
  var _useSuggestSelectedIt = useSuggestSelectedItem(props, {
      suggestionsChildrenRef: headerRef,
      listBoxRef: listRef
    }),
    setSelectedItemIndex = _useSuggestSelectedIt.setSelectedItemIndex,
    selectedItemIndex = _useSuggestSelectedIt.selectedItemIndex;
  var mouseEventProps = useSuggestMouseEvents(setSelectedItemIndex);
  if (!props.open || !props.suggestions.length && !props.emptyListText) {
    return props.children;
  }
  var NoItemsComponent = !props.suggestions.length && props.emptyListText && /*#__PURE__*/_jsx(SuggestionTextItem, {
    children: props.emptyListText
  });
  return /*#__PURE__*/_jsx(ModalWindow, {
    open: true,
    onClose: onModalClose,
    title: props.title,
    height: "100%",
    width: "100%",
    fixed: true,
    header: /*#__PURE__*/_jsx(SuggestModalMobileHeader, {
      ref: headerRef,
      children: props.children
    }),
    content: /*#__PURE__*/_jsxs(SuggestModalMobile, {
      ref: listRef,
      children: [NoItemsComponent, props.suggestions.map(function (suggestion, i) {
        var _suggestion$type;
        var ItemComponent = suggestItemComponentMap[(_suggestion$type = suggestion.type) !== null && _suggestion$type !== void 0 ? _suggestion$type : SUGGEST_PROP_DEFAULTS.itemType];
        return /*#__PURE__*/_createElement(ItemComponent, _objectSpread(_objectSpread({}, suggestion), {}, {
          key: i,
          type: suggestion.type,
          iconMargin: getIconMarginForItem(suggestion),
          ref: suggestion.type === 'title' ? setTitleItemRefByIndex(i) : undefined,
          onClick: onItemClick(suggestion),
          isSelected: selectedItemIndex === i,
          onMouseMove: mouseEventProps.onMouseMove(i),
          onMouseLeave: mouseEventProps.onMouseLeave,
          onMouseEnter: mouseEventProps.onMouseEnter,
          variant: "mobile"
        }), /*#__PURE__*/_jsx(TextHighlighter, {
          highlightValue: props.highlightValue,
          children: suggestion.title
        }));
      })]
    })
  });
};